import { Feature, FeatureCollection, Point } from 'geojson';
import transform from 'geojson-transformer';
import { create, findNear, IPointToPhoto, remove, uploadPhoto } from '../../api/operation/pointToPhoto';
import SingletonEventEmitterClass from '../SingletonEventEmitterClass';
import LngLat = mapboxgl.LngLat;

export default class PointToPhotoLoader extends SingletonEventEmitterClass {
  public photoGeoJson: FeatureCollection<Point> = {
    type: 'FeatureCollection',
    features: [],
  };
  public afterStockPlaceGeoJson: FeatureCollection<Point> = {
    type: 'FeatureCollection',
    features: [],
  };
  public beforeStockPlaceGeoJson: FeatureCollection<Point> = {
    type: 'FeatureCollection',
    features: [],
  };

  private _data: IPointToPhoto[] = [];

  public _triggerPointsUpdated() {
    this.emit('photo_points_updated');
  }

  public onMapUpdatedCenter(center: ILngLat) {
    this._findPoints(center);
  }

  public onMapRightClick(id: string) {
    this._removePoint(id);
  }

  public onCreatePoint(e: React.ChangeEvent<HTMLInputElement>, lngLat: LngLat) {
    (async () => {
      const file: File = e.target.files![0];
      const { data } = await uploadPhoto(file);
      this._addPoint([lngLat.lng, lngLat.lat], data.cdnUrl);
    })();
  }

  private _addPoint(lngLat: ILngLat, photo: string) {
    (async () => {
      const { data } = await create(lngLat, photo, false);
      data.location.gcj02Geometry = transform(data.location.gcj02Geometry, 'gcj02', 'wgs84');
      this._data.push(data);
      this._triggerPointsUpdated();
    })();
  }

  private _removePoint(id: string) {
    (async () => {
      await remove(id);
      this._triggerPointsUpdated();
    })();
  }

  private async _findPoints(center: ILngLat) {
    const { data } = await findNear(transform(center, 'wgs84', 'gcj02'), 1000, false);
    this._data = data.map(item => {
      item.location.gcj02Geometry = transform(item.location.gcj02Geometry, 'gcj02', 'wgs84');
      return item;
    });
    this._handleData(this._data);
    this._triggerPointsUpdated();
  }

  private _handleData(data: IPointToPhoto[]) {
    const photoData: Array<Feature<Point>> = [];
    const afterData: Array<Feature<Point>> = [];
    const beforeData: Array<Feature<Point>> = [];
    data.forEach(point => {
      const feature: Feature<Point> = {
        type: 'Feature',
        geometry: point.location.gcj02Geometry,
        properties: {
          id: point._id,
          photo: point.photo,
          createdAt: new Date(point.createdAt).toLocaleString(),
          creator: point.creator && point.creator.cert && point.creator.cert.name,
          type: point.type,
          processed: point.processed,
          info: { ...point, layerType: 'pointToPhoto' },
        },
      };
      if (point.type === 0) {
        photoData.push(feature);
      } else {
        !point.processed ? afterData.push(feature) : beforeData.push(feature);
      }
    });
    this.photoGeoJson.features = photoData;
    this.afterStockPlaceGeoJson.features = afterData;
    this.beforeStockPlaceGeoJson.features = beforeData;
  }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/classes/loaders/PointToPhotoLoader.ts